import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutePath } from 'app/routing/routes';
import { UserInfo } from 'app/_models';
import { ConfigService } from 'app/_services/config.service';
import { UserService } from 'app/_services/user.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
    openSubmenu = false;
    RoutePath = RoutePath;
    user: UserInfo = null;
    role: string;
    IsDevSite = true;

    constructor(private router: Router, private userService: UserService, private configService: ConfigService) {
        this.user = this.userService.UserValue;
        this.role = this.user?.CurrentRole.roleName;
        this.IsDevSite = this.configService.hostAddress === "http://districtwebsiteappdev.polk-fl.net"; //TODO: Improve check for dev site
    }

    ngOnInit(): void {}
}
